
import { defineComponent, Ref, ref, watch } from "vue";
import type { PropType } from "vue";
import Api from "@/services/Api";
import useAlert from "../../../composables/Alert";



export default defineComponent({
  name: "ModalPlanilhaVeiculo",
  props: {
    arquivo: Object as PropType<any>,
    rodandoFila: Boolean,
    alteraRodandoFila: Function,
    fechaModal: Function,
    abreModal: Function,
  },

  setup(props) {

    const { showTimeAlert } = useAlert();

    const arquivo: Ref<any> = ref({});

    const modalDialogo: Ref<any> = ref()
    const loadingBaixarPlanilha = ref(false)
    const loadingRodaPlanilha = ref(false)

    function close(){
      arquivo.value = {};
      props.fechaModal && props.fechaModal()
    }

    function abreModal(){
      arquivo.value = props.arquivo
    }

    async function baixaPlanilha(arquivo: any) {

      try{
        loadingBaixarPlanilha.value = true
        const response = await Api.get('baixaPlanilhaFiltros', { filePath:  'planilhas/veiculo/', fileName: props.arquivo.nome }, { responseType: 'blob' })
        baixaArquivo(response, arquivo.nome)

      }catch(error){
        console.log(error)
        showTimeAlert('ocorreu um erro inesperado!', "error")
      }finally{
        loadingBaixarPlanilha.value = false
      }
     
    }

    function baixaArquivo(blobParam:any, name:string) {
      const url = URL.createObjectURL(new Blob([blobParam]));
      const link = document.createElement('a');
      link.href = url;
      link.download = name
      link.click();
      URL.revokeObjectURL(url);
    }

    async function rodaPlanilha() {

      props.alteraRodandoFila && props.alteraRodandoFila(true)
      loadingRodaPlanilha.value = true

      try {

        const nomeArquivo = arquivo.value.nome;
  
        const { data } = await Api.get("processaFilaPorNome", { nome: nomeArquivo })
  
        if(data.erro) return showTimeAlert(data.mensagem, "error")
        
        showTimeAlert(data.mensagem)

      } catch (error) { 
        console.log(error); showTimeAlert('ocorreu um erro inesperado!', "error") 
        loadingRodaPlanilha.value = false
        props.alteraRodandoFila && props.alteraRodandoFila(false)
      }

      props.alteraRodandoFila && props.alteraRodandoFila(false)
      loadingRodaPlanilha.value = false

      close()
    }

    watch(() => props.arquivo, async () => { abreModal() }, { deep: true })

    return {
      close,
      modalDialogo,
      baixaPlanilha,
      rodaPlanilha,
      loadingBaixarPlanilha,
      loadingRodaPlanilha
    };
  },
});
